"use client";
import useConfirm from "@/hooks/use-confirm";
import { useEffect, useState } from "react";
import { FaSpinner } from "react-icons/fa";
import { useSearchParams } from "react-router-dom";
import ResendCode from "./resend-code";
import VerifiedEmail from "./verified-email";

function ConfirmEmail() {
  const [searchParams] = useSearchParams();
  const code = searchParams.get("code");
  const [confirmed, setConfirmed] = useState(false);
  const { confirm, resendCode, isLoading } = useConfirm();
  const email = searchParams.get("email");
  useEffect(() => {
    const confirmEmail = async () => {
      if (code && email) {
        try {
          const response = await confirm({ email, code });
          if (response) {
            setConfirmed(true);
          }
        } catch (err) {
          setConfirmed(false);
          console.log(err);
        }
      }
    };
    confirmEmail();
  }, [code, email]);
  if (isLoading) {
    return (
      <div>
        <FaSpinner />
      </div>
    );
  } else if (confirmed) {
    return <VerifiedEmail />;
  } else if (!confirmed && email) {
    return <ResendCode onClick={() => resendCode(email)} />;
  }
}

export default ConfirmEmail;
